import { useState, useEffect } from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { DateTime } from "luxon";
import { t } from "i18next";

// COMPONENTS
import TableListBonosES from "@/shared/components/organisms/TableListBonosES";
import { CalendarUser } from "@/shared/components/organisms/CalendarUser";
import { ListHistorial } from "@/shared/components/organisms/ListHistorial";
import { ButtonSoft } from "@/shared/components/atoms/ButtonSoft";
import { TabsUser } from "@/shared/components/organisms/TabsUser";

// APIS
import { useSlotsUserQuery } from "@/app/slots/slots.api";
import { useAssignedBondsQuery } from "@/app/bonds/bonds.api";

// UTILS
import { selectUser } from "@/app/auth/auth.slice";
import { formatDateTime } from "@/shared/utils/formatedDate";

export const SlotsAssignment = ({
  handleOpenDialogAsingAssisteds,
  handleOpenDialogAssingBond,
  handleOpenDialogEditBond,
  userShowData,
  userSelected,
  branch_id,
}: any) => {
  const { id } = useParams();
  const user = useSelector(selectUser);
  const [idBranch, setIdBranch] = useState(0);
  const [activityBonds, setActivityBonds] = useState([]);
  const [month, setMonth] = useState(DateTime.now().toFormat("yyyy-MM"));

  const assignedBondsQuery = useAssignedBondsQuery(
    idBranch > 0 ? { branchId: idBranch, userId: id } : skipToken
  );

  useEffect(() => {
    if (branch_id) {
      setIdBranch(branch_id);
    }
  }, [branch_id]);

  useEffect(() => {
    if (userSelected) {
      setIdBranch(userSelected.branch.id);

      setActivityBonds(
        userSelected.bondHistory.map((bond) => ({
          name: bond.bond ? bond.bond.name : "",
          description: t(bond.description),
          date: formatDateTime(bond.createdAt),
        }))
      );
    }
  }, [userSelected]);

  //TABS ES
  const [selectedTabES, setSelectedTabES] = useState(1);
  const tabsES = [
    { id: 1, name: t("slot-bonds.views.calendar") },
    { id: 2, name: t("slot-bonds.views.title") },
    { id: 3, name: t("user.views.history") },
  ];
  const handleTabChangeES = (tabId: any) => {
    setSelectedTabES(tabId);
  };

  const slotsUserQuery = useSlotsUserQuery(
    idBranch > 0
      ? { branchId: idBranch, groups: [], userId: id, month: month }
      : skipToken
  );

  return (
    <>
      <h1 className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-200 pb-3 mt-10  mb-5 md:mb-3">
        {t("slots.views.title")}
      </h1>
      <TabsUser
        tabs={tabsES}
        selectedTab={selectedTabES}
        handleTabChange={handleTabChangeES}
        button={
          <ButtonSoft
            text={t("user.views.manage_slots")}
            size="large"
          />
        }
      />
      {selectedTabES === 1 ? (
        <div className="w-full">
          <CalendarUser
            initialDateTime={DateTime.now()}
            events={(slotsUserQuery.data ?? []).map((slot) => ({
              ...slot,
              name: slot.slotPlace?.slotGroup?.name,
            }))}
            loading={slotsUserQuery.isLoading}
            //onEventClick={(event) => {
            //console.log(event);
            //}}
            onEventClick={(lesson) => {
              handleOpenDialogAsingAssisteds(lesson);
            }}
            onMonthChange={(date) => {
              setMonth(date.toFormat("yyyy-MM"));
              slotsUserQuery.refetch();
            }}
            functionOpenModalActividades={() => {}}
          />
        </div>
      ) : (
        <>
          {selectedTabES === 2 ? (
            <>
              <TableListBonosES
                user={userSelected ?? {}}
                loggedUser={user}
                assignedBonds={assignedBondsQuery.data ?? []}
                bonos={userShowData.slotBonds ?? []}
                titleBranded={t("bond.views.assign")}
                titleBrandedActiveFee={t("share.views.edit")}
                onAssingBond={handleOpenDialogAssingBond}
                onEditBond={handleOpenDialogEditBond}
                updateBondUserButton={() => {
                  console.log("Console");
                }}
              />
            </>
          ) : (
            <>
              {selectedTabES === 3 ? (
                <>
                  <ListHistorial history={activityBonds} />
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}